<template>
  <!-- 购物车 -->
  <div>
    <div class="page-title font-s24 c33 " style="padding-bottom: 20px;">
      购物车
    </div>
    <div v-if="list.length>0">
      <div class="cart">
        <div class="container" v-for="(item,index) in list" :key="index">
          <div class="cart-list clearfix">
            <div class="fl list-l">
              <img :src="item.imgs" width="100%" />
            </div>
            <div class="fl list-r clearfix">
              <div class="clearfix">
                <div class="fl c33 bold font-s24">
                  {{item.title}}
                </div>
                <div class="fr c66" @click="delShopping(item,index,'')">
                  <img src="../../../src/assets/image/delShopping.png" width="100%"/>
                </div>
              </div>
              <div class=" font-s16 c66 pd-t-20">{{item.note}}</div>
              <div class="bottom font-s20 bold cff9">￥{{item.price}}</div>
            </div>
            <!-- 灰色删除 -->
            <div class="masking" v-if="item.flag">
              <div class="content">
                <div class="fl cff bold font-s24 pd-b-20">
                  确定要删除该商品?
                </div>
                <div>
                  <el-button plain @click="delShopping(item,index,'确定删除')">确定删除</el-button>
                  <el-button type="info" @click="delShopping(item,index,'')">再想想</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 支付 -->
      <div class="cart-pay clearfix">
        <div class="fr">
          <div>
            <span>需支付：</span>
            <span class="font-s14 bold cff9">￥</span>
            <span class="font-s20 bold cff9">{{totalPrice}}</span>
          </div>
          <div class="pd-t-10">
            <el-button type="warning" @click="pay">立即支付</el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>暂无数据</div>
            <!--  -->
    <el-dialog
      title="支付订单"
      :visible.sync="dialogVisible"
      width="660px"
      :before-close="handleClose"
      >
    <div class="dialogTreat" >
      <div>
        <div>商品名称：<span>{{payData.title}}</span></div>
      </div>
      <div>
        <div>订单编号：<span>{{payData.order_no}}</span></div>
      </div>
      <div>
        <div>交易金额：<span>￥{{payData.price}}</span></div>
      </div>
      <div class="pay2 pd-t-30 text-center">
          <div class="text-center">
              <div id="qrCode" ref="qrCodeDiv" class="pd-t-20 treatment-code"></div>
              <div class="pd-t-30 font-s24  cff9">{{payData.price}}</div>
              <div class="c33 font-s20" style="padding-top:12px">微信扫一扫付款（元）</div>
          </div>
      </div>
    </div>
    </el-dialog>
        <!--  -->
  </div>
</template>
<script>
import { CarList,DelCarInfo,Settlement } from "../../api/api";
import QRCode from "qrcodejs2";
export default {
  data() {
    return { 
      item: this.$route.query.item == undefined ? "" : JSON.parse(this.$route.query.item),
      list: [],
      dialogVisible: false,
      payData:'',
      totalPrice:0,//支付金额
      orderStuats:false,//订单状态
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$axios.post(CarList, {}).then(
        res => {
          if (res.data.code == 1) {
            this.list = res.data.data.datas;
            this.payPrice();
          } else {
            this.list = [];
            if (res.data.data.is_login == false) {
              var item = {
                from: "cart", //从哪个页面转入
                id: "",
                type: ""
              };
              this.$router.push({
                name: "userCenter",
                query: { item: JSON.stringify(item) }
              });
            }
          }
        },
        err => {
          this.list = [];
        }
      );
    },
    delShopping(item,index,btnName){
      if(btnName=='确定删除'){
        this.$axios.post(DelCarInfo, {car_id:item.car_id}).then(
        res => {
          if (res.data.code == 1) {
            this.getList();
            this.payPrice();
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
          } else {
            this.$message.error(res.data.msg);
          }
        },
        err => {
          this.list = [];
        }
      );
      }else{
        this.$set(item,'flag',!item.flag)
      }
    },
    payPrice(){//计算支付金额
       var array=this.list
       if(array.length>0){
         var total=0;
           for(var i=0;i<array.length;i++){
             total=total+parseInt(array[i].price);
           }
           this.totalPrice=total
       }
    },
    pay(){//支付
      this.orderStuats=false
      let result = this.list.map(i => {return i.car_id}).join()
        var db={
          car_ids:result
        }
      this.$axios.post(Settlement, db).then(
          res => {
          if (res.data.code == 1) {
              this.payData=res.data.data;
              this.$nextTick(function() {
                  this.bindQRCode();
                      //  获取微信支付后的状态
                      if(this.orderStuats==false){
                          this.payStuats();
                      }
              });
            this.dialogVisible=true;
          } else {}
          },
          err => {}
      );
    },
    payStuats(){
            var db={
                order_no:this.payData.order_no
            }
            setInterval(()=>{
                if(this.orderStuats==false){
                    if(this.$route.path=='/healthCare/treatmentPlan'){
                    this.$axios.post(GetOrderStatus, db).then(
                        res => {
                            if (res.data.code == 1) {
                                this.orderStuats=true;
                                this.$router.push({name:'userMyTest'}); 
                            }
                        }
                    );                  
                }
                }
              
        }, 1000);
    },
     bindQRCode: function() { //显示二维码
      new QRCode(this.$refs.qrCodeDiv, {
        text: this.payData.url,
        width: 200,
        height: 200,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        marginLeft: '200px',
        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
      });
    },
     handleClose(done){
        this.orderStuats=true;
        done();
    },
  }
};
</script>
<style lang="scss" scoped>
.cart {
  border: 1px #f2f2ff solid;
  padding: 0 20px 0;
  .container {
    padding: 20px 0;
    border-bottom: 1px #f2f2ff solid;
  }
  .cart-list {
    position: relative;

    .list-l {
      padding-right: 20px;
      width: 30%;
    }
    .list-r {
      width: 67%;
    }
    .bottom {
      position: absolute;
      bottom: 0;
    }
    //   灰色删除
    .masking {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      background: rgba(0, 0, 0, 0.5);
      .content {
        width: 210px;
        margin: 0 auto;
        padding-top: 7%;
      }
    }
  }
}
.cart-pay {
  padding-top: 30px;
  .el-button {
    padding: 12px 34px;
  }
}
   .dialogTreat{
      border-top: 1px #eeeeee solid;
   }
   .dialogTreat>div:not(:last-child){
       padding-top: 20px;
       font-size: 14px;
       div{
            color: #999999;
       }
       span{
            color: #333;
       }
   }

.treatment-code{
  margin-left: 200px;
}


</style>
